import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * คอร์สดี.com / coursedee.web.app ใช้แอป/โฮสต์เดียวกับ Edumi
 * Guard นี้กันไม่ให้หน้าเฉพาะของ Edumi (เช่น ต่ออายุ subscription, instructor, pricing)
 * โผล่บนโดเมนคอร์สดี — ถ้าเข้าถึง path เหล่านี้บนโดเมนคอร์สดี จะ redirect กลับหน้าแรกคอร์สดี
 *
 * ใช้ blacklist (เฉพาะ path ที่เป็นของ Edumi ชัด ๆ) เพื่อไม่ให้บล็อก path ของคอร์สดีโดยไม่ตั้งใจ
 */

// path prefixes ที่เป็นของ Edumi/Salepage ล้วน ไม่ควรโผล่บนคอร์สดี
const EDUMI_ONLY_PREFIXES = [
  '/subscription/renew',
  '/subscription/manage',
  '/subscription/billing',
  '/subscription/checkout-summary',
  '/instructor',
  '/student',
  '/learning',
  '/certificate',
  '/moderator',
  '/pricing',
  '/salepage',
];

const isCoursedeeHost = (): boolean => {
  const hn = typeof window !== 'undefined' ? window.location.hostname : '';
  return hn.includes('aiforyou');
};

const isEdumiOnlyPath = (pathname: string): boolean =>
  EDUMI_ONLY_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(prefix + '/'));

export default function CoursedeeRouteGuard() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isCoursedeeHost()) return;
    if (isEdumiOnlyPath(location.pathname)) {
      console.log('[CoursedeeRouteGuard] Blocking Edumi-only path on coursedee host:', location.pathname);
      navigate('/', { replace: true });
    }
  }, [location.pathname, navigate]);

  return null;
}
